import styled, { css } from 'styled-components'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'

const Display = styled.div`
    ${({ mobile }) => mobile != null && css`
        display: ${mobile === true ? 'block' : mobile} !important;
    `}

    ${({ tablet }) => tablet != null && css`
        @media (min-width: ${TABLET}px) {
            display: ${tablet === true ? 'block' : tablet} !important;
        }
    `}

    ${({ desktop }) => desktop != null && css`
        @media (min-width: ${DESKTOP}px) {
            display: ${desktop === true ? 'block' : desktop} !important;
        }
    `}
`

export default Display
